import AuthRoute from "../AuthRoute";
import { authGuardLoader } from "routes/loaders/authGuardLoader";

const landingPageRoutes = [
  {
    path: "/",
    loader: authGuardLoader,
    lazy: async () => {
      const [loginMod, errorMod] = await Promise.all([
        import("views/Authentication/Login/new-login-flow"),
        import("views/ErrorPage/SpeakerNotFound"),
      ]);
      const NewLogin = loginMod.default;
      const SpeakerNotFound = errorMod.default;
      return {
        Component: () => (
          <AuthRoute>
            <NewLogin />
          </AuthRoute>
        ),
        ErrorBoundary: SpeakerNotFound,
      };
    },
  },
];

export default landingPageRoutes;
